import { ResourceStatusEnum } from '@/types/schema';

export const getSubHeaderStatus = (status: ResourceStatusEnum) => {
  return status !== ResourceStatusEnum.Revoked
    ? ResourceStatusEnum.Active
    : ResourceStatusEnum.Revoked;
};

export default getSubHeaderStatus;
